<template>
  <div v-if="allRelances">
    <transition-group name="relanceList">
      <div v-for="item in allRelances" :key="item.id">
        <div class="card is-cursor-pointer mgb-20px"
            :class=getClassBorder(item.id)
            @click="$emit('changeCurrentRelance', item.id)">
          <div class="card-content is-relative pd-10px">
            <div class="columns mgb-0">
              <div class="column is-2">
                <b-icon icon="file" type="is-primary" size="is-medium"></b-icon>
                <br>
                <b-icon :icon="getIconRelanceNiveau(item.numRelance)"
                  size="is-medium" class="mgt-5px">
                </b-icon>
              </div>
              <div class="column">
                <client-avec-blocage :tiers="getPayeurWithAdditionalData(item)" :is-detail="true"/>
                <adresse-detail :adresse="item.payeur.adresse"
                  :hideIntitule="true" :tiersId="item.payeurId"
                  v-if="item.payeur.adresse"
                  class="is-size-7 has-text-default is-marginless"/>
              </div>
              <b-tag v-if="!item.actif"
                type="has-background-subMenu"
                class="has-text-white mgt-10px column is-narrow">
                {{$t('relance.etat.archive')}}
              </b-tag>
              <div class="column is-narrow is-relative has-text-right">
                <div
                  v-if="allRelances.length > 1  && !isDetail"
                  @click.prevent.stop="openPopUpAnnulation(item.id)">
                  <b-tooltip :label="$t('relance.annulerRelance')"
                    position="is-bottom">
                    <b-icon icon="close-circle" type="is-danger"></b-icon>
                  </b-tooltip>
                </div>
                <p class="is-size-7">
                  {{ item.dateRelance | formatDate }}
                </p>
                <p :class="{ 'has-text-success': item.etat === etatEnvoye }"
                  class="is-size-7">
                  {{ $t(getEtat(item.etat)) }}
                </p>
              </div>
            </div>
            <div class="level mgb-10px is-align-items-end">
              <div class="level-left">
                <p v-if="item.etat === etatEnvoye" class="is-size-7">
                  <span>
                    {{$t('relance.destinataire')}}
                  </span>
                  <br>
                  <span >{{ getDestinataire(item) }}</span>
                  <br v-if="getDestinataire(item)">
                  <span>{{ item.emailDestinataire }}</span>
                </p>
              </div>
              <div class="level-right">
                <p class="has-text-weight-bold">
                  {{ getMontantRelance(item.mouvementsClients) | formatDevise }}
                </p>
              </div>
            </div>
            <hr>
            <div class="columns is-multiline is-size-7 is-marginless pdb-0"
              v-for="(mvt, index) in item.mouvementsClients"
              :key="index">
              <div class="column is-2 is-paddingless">
                {{ $t('relance.factureN') }}
              </div>
              <div class="column is-3 is-paddingless">
                <router-link-blank
                  :to="{ name: 'c.bodac.factures', params: {id: mvt.facture.id}}"
                  :class="{'text-access-no-permission': !checkPermissions(perms.facture.lecture)}"
                  :message="mvt.facture.code">
                </router-link-blank>
              </div>
              <div class="column is-5 is-paddingless has-text-weight-bold">
                {{ $t('relance.echDate') }} {{  mvt.dateEcheance | formatDate }}
              </div>
              <div
                class="column is-2 is-paddingless
                  text-align-end has-text-weight-bold is-marginless">
                {{ mvt.resteAPayer | formatDevise }}
              </div>
            </div>
          </div>
          <div
            v-if="allRelances.length > 1  && !isDetail"
            class="button card-footer is-primary"
            @click="emitIdMouvement(item.id)">
            {{$t('general.button.sauvegarder')}}
          </div>
        </div>
      </div>
    </transition-group>
    <b-modal v-model="popUpAnnulation" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('relance.titlePopUpAnnulerRelance')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="closePopUpAnnulation"
        @yes="deleteRelance">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import adresseDetail from '@/components/general/adresseDetail';
import popUpPrevention from '@/components/general/popUpPrevention';
import clientAvecBlocage from '@/components/general/clientAvecBlocage';
import { FACTURES } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { ETAT_RELANCES, ENVOYE, ENREGISTRE } from '@/configuration/relances/relancesConf';

const permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      popUpAnnulation: false,
      idRelanceAAnnuler: null,
      perms: {
        facture: FACTURES,
      },
      etatEnvoye: ENVOYE,
      etatEnregistre: ENREGISTRE,
    };
  },
  props: {
    allRelances: {
      type: Array,
      required: true,
    },
    idCurrentRelance: {
      type: String,
      required: false,
    },
    isDetail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    adresseDetail,
    popUpPrevention,
    clientAvecBlocage,
    routerLinkBlank,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    getClassBorder(id) {
      if (id === this.idCurrentRelance) return 'borderPrimary';
      return '';
    },
    emitIdMouvement(id) {
      this.$emit('saveRelance', id);
    },
    getIconRelanceNiveau(numRelance) {
      if (numRelance === 1) return 'numeric-1-circle-outline';
      if (numRelance === 2) return 'numeric-2-circle-outline';
      return 'numeric-3-circle-outline';
    },
    getMontantRelance(mouvementClients) {
      return mouvementClients.map(mvt => mvt.montantEcheance)
        .reduce((a, b) => a + b, 0);
    },
    openPopUpAnnulation(idRelance) {
      this.idRelanceAAnnuler = idRelance;
      this.popUpAnnulation = true;
    },
    closePopUpAnnulation() {
      this.popUpAnnulation = false;
      this.idRelanceAAnnuler = null;
    },
    deleteRelance() {
      this.$emit('deleteRelance', this.idRelanceAAnnuler);
      this.closePopUpAnnulation();
    },
    getEtat(etat) {
      const etatRelance = ETAT_RELANCES.find((el) => { return el.etat === etat; });
      if (etatRelance) {
        return etatRelance.libelle;
      }
      return String.empty;
    },
    getDestinataire(item) {
      return [item.prenomDestinataire, item.nomDestinataire]
        .filter(el => !!el).join(' ');
    },
    getPayeurWithAdditionalData(item) {
      return {
        ...item.payeur,
        descriptionBlocage: item.payeurDescriptionBlocage,
        blocageLevel: item.payeurBlocageLevel,
      };
    },
  },
};
</script>
